import React, { useEffect, useState } from 'react';
import QRCode from "react-qr-code";
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
      children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props}  children={props.children}/>;
});

interface CurrentOrderCodesItemProps {
    item: any;
    isDineIn: boolean;
}

const CurrentOrderCodesItem = (props: CurrentOrderCodesItemProps) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [width, setWidth]   = useState(window.innerWidth);
    
    const updateDimensions = () => {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    
    const handleClickOpen = () => {
        console.log("dialog props.item: ", props.item);
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };
    
    return (
        <div className="currentOrderCodesItem__container">
            {
                props.item && (
                    <div className="currentOrderCodesItem__container_content" onClick={handleClickOpen}>
                        <div className="currentOrderCodesItem__container_content_image">
                            <div className="currentOrderCodesItem__container_content_image_status">
                                {
                                    !props.isDineIn && props.item.isPaid ? (
                                      <div className="currentOrderCodesItem__container_content_image_status_data">
                                          <span>{t(`cart.paid`)}</span>
                                      </div>
                                    ) : null
                                }
                            </div>
                            <img
                              src={props.item.dineInAdId ?
                                props.item.restaurantId.images &&
                                props.item.restaurantId.images.length > 0 ?
                                  props.item.restaurantId.images[0] :
                                  "" :
                                props.item.takeOutAdId.image &&
                                props.item.takeOutAdId.image
                              }
                              alt={props.isDineIn ? props.item.dineInAdId?.name : props.item.takeOutAdId?.name}
                            />
                            <div className="currentOrderCodesItem__container_content_image_qr">
                                <div className="currentOrderCodesItem__container_content_image_qr_code">
                                    <QRCode
                                      value={`${process.env.REACT_APP_API_URL ?? "http://3.9.77.124:3001"}/cart/${props.item._id}`}
                                      size={38}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="currentOrderCodesItem__container_content_place">
                            <div className="currentOrderCodesItem__container_content_place_address">
                                <span>
                                    {props.item?.restaurantId?.address?.name || ""}
                                </span>
                            </div>
                            <div className="currentOrderCodesItem__container_content_place_time">
                                <span>{props.item.reservationTime}</span>
                            </div>
                        </div>
                        <div className="currentOrderCodesItem__container_content_data">
                            <div className="currentOrderCodesItem__container_content_data_name">
                                <span>{
                                    props.isDineIn ?
                                      t(`const.${props.item.dineInAdId.onOption.toLowerCase()}`)                                   
                                    : 
                                      props.item.takeOutAdId?.name
                                }</span>
                            </div>
                            {
                                props.isDineIn ? (
                                  <div className="currentOrderCodesItem__container_content_data_price">
                                      {/*<div className="currentOrderCodesItem__container-data-price">
                                      <span>{props.item.dineInAdId.discount}%</span>
                                  </div>*/}
                                      <div className="currentOrderCodesItem__container_content_data_price_discount">
                                          {/* <span>{props.item.dineInAdId.discount}%</span> */}
                                          <span>{props.item.dineInAdId.discount}% {t('const.discount')}</span>
                                      </div>
                                  </div>
                                ) : (
                                  <div className="currentOrderCodesItem__container_content_data_price">
                                      <div className="currentOrderCodesItem__container_content_data_price_now">
                                          <span>€{props.item.takeOutAdId.priceBefore}</span>
                                      </div>
                                      <div className="currentOrderCodesItem__container_content_data_price_discount">
                                          <span>€{props.item.takeOutAdId.priceNow}</span>
                                      </div>
                                  </div>
                                )
                            }
                        </div>
                    </div>
                )
            }
          {
            props.item && (
              <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                className={"currentOrderCodesItem__container_dialog"}
              >
                <div className="currentOrderCodesItem__container_card">
                    <div className="currentOrderCodesItem__container_card_close">
                        <button onClick={handleClose}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path d="M9.99992 10.0001L29.7989 29.7991M29.7989 10.0001L9.99992 29.7991" stroke="black" strokeOpacity="0.4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                  <div className="currentOrderCodesItem__container_card_image">
                    <div className="currentOrderCodesItem__container_card_image_reservation">
                      <span>{props.isDineIn ? t(`const.dineIn`) : t(`const.takeOut`)}</span>
                    </div>
                    <img
                      src={props.isDineIn ? props.item.restaurantId.images[0] : props.item.takeOutAdId?.image}
                      alt='card image'
                    />
                    <div className="currentOrderCodesItem__container_card_image_name">
                      <div className="currentOrderCodesItem__container_card_image_name_text">
                        <span>{
                            props.isDineIn ?
                              t(`const.${props.item.dineInAdId.onOption.toLowerCase()}`)
                              :
                              props.item.takeOutAdId?.name
                        }</span>
                      </div>
                      {
                        props.isDineIn ? (
                          <div className="currentOrderCodesItem__container_card_image_name_price">
                            <div className="currentOrderCodesItem__container_card_image_name_price_discount">
                              <span>{props.item.dineInAdId.discount}% {t(`const.discount`)}</span>
                            </div>
                          </div>
                        ) : (
                          <div className="currentOrderCodesItem__container_card_image_name_price">
                            <div className="currentOrderCodesItem__container_card_image_name_price_before">
                              <span>€{props.item.takeOutAdId?.priceBefore}</span>
                            </div>
                            <div className="currentOrderCodesItem__container_card_image_name_price_discount">
                              <span>€{props.item.takeOutAdId?.priceNow}</span>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                    
                    <div className="orderMainDetails__container-description pay">
                        <div className="orderMainDetails__container-description-wrap">
                            <div className="orderMainDetails__container-description-time-wrap pay">
                                <div className="orderMainDetails__container-description-title-wrap pay">
                                    <div className="orderMainDetails__container-description-title payment">
                                        {
                                            props.isDineIn ? props.item?.isConfirmed ?
                                                <img src={`${process.env.PUBLIC_URL}/images/done-icon.png`} alt="done" />
                                                : null
                                              : props.item?.isPaid ?
                                                <img src={`${process.env.PUBLIC_URL}/images/done-icon.png`} alt="done" />
                                                : null
                                        }
                                        <span>{
                                            props.isDineIn
                                              ?
                                              props.item?.isConfirmed
                                              ?
                                                t(`cart.reservationSuccess`)
                                                :
                                                t(`cart.awaitingConfirmation`)
                                              :
                                              props.item?.isPaid
                                                ?
                                                t(`cart.paymentSuccess`)
                                                :
                                                t(`cart.awaitingPayment`)
                                        }</span>
                                    </div>
                                </div>
                                <div className="orderMainDetails__container-description-title-wrap pay">
                                    <div className="orderMainDetails__container-description-title">
                                        {/* <span>{props.isDineIn ? props.item.restaurantId.name : 'category'}</span> */}
                                        <span>{props.item.restaurantId.name}</span>
                                    </div>
                                    <div className="orderMainDetails__container-description-place">
                                        <span>{props.item.restaurantId?.address?.name}</span>
                                    </div>
                                </div>
                                <div className="orderMainDetails__container-description-dine-in-wrap">
                                    <div className="orderMainDetails__container-description-dine-in-wrap-image">
                                        <img
                                          src={`${process.env.PUBLIC_URL}/images/dine-in-icon.svg`}
                                          alt='dine-in-icon'
                                        />
                                    </div>
                                    <div className="orderMainDetails__container-description-dine-in">
                                        <span>{props.isDineIn ? `${props.item.guestsNr} ${t('const.guests')}` : `${props.item.mealsNr} ${t('const.meals')}`}</span>
                                    </div>
                                </div>
                                <div className="orderMainDetails__container-description-timer-wrap">
                                    <div className="orderMainDetails__container-description-timer-wrap-image">
                                        <img
                                          src={`${process.env.PUBLIC_URL}/images/timer-icon.svg`}
                                          alt='timer-icon'
                                        />
                                    </div>
                                    <div className="orderMainDetails__container-description-timer">
                                        <span>{props.item.reservationTime} </span>
                                    </div>
                                </div>
                            </div>
                            <div className="orderMainDetails__container_qr">
                                <QRCode
                                  value={`${props.item._id}`}
                                  size={width > 767 ? 200 : 140}
                                />
                                <div className="orderMainDetails__container_qr_text">
                                    <span>{t(`cart.weSendQRCodeToEmail`)}</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="orderMainDetails__container-buttons-wrap pay">
                            <Button
                              className="orderButtons__container-button-btn dine-in"
                              variant="contained"
                              onClick={() => navigate('/food')}
                            >
                                <span>{t(`buttons.findMore`)}</span>
                            </Button>
                        </div>
                    </div>
                
                </div>
              </Dialog>
            )
          }
        </div>
    );
};

export default CurrentOrderCodesItem;